<template>
    <div v-bind="$attrs" @click="tryOpenModal" class="cursor-pointer">
        <slot></slot>
    </div>
    <ModalCustom
        :is-open="state.isLoadModalOpen"
        @close="tryCloseLoadModal"
        :title="`Tags for ${video.title}`"
    >
        <div class="w-[80vw] max-h-[50vh] overflow-y-auto">
            <div class="mt-2 p-4 flex gap-4 items-start">
                <div
                    class="
                        grid grid-cols-3
                        gap-4
                        lg:grid-cols-4
                        flex-grow flex-shrink
                    "
                >
                    <div
                        v-if="state.tags.length === 0"
                        class="col-span-4 self-center"
                    >
                        <div class="text-center text-gray-500">
                            No plays associated with this video
                        </div>
                    </div>
                    <div
                        v-for="play in state.tags"
                        :key="play.play_id"
                        class="
                            p-8
                            pt-4
                            bg-white
                            shadow-xl
                            rounded-lg
                            border border-gray-200
                        "
                    >
                        <a
                            :href="`${href}?play_id=${play.play_id}&ref=video&ref-id=${video.id}`"
                            class="text-center cursor-pointer"
                        >
                            <div class="flex items-center justify-center">
                                <div class="flex-grow flex-shrink">
                                    <h3 class="font-semibold">
                                        {{ play.play_name }}
                                    </h3>
                                </div>
                            </div>
                            <div class="mt-4">
                                <img
                                    :src="
                                        play.thumbnail_url ??
                                        `${previewUrl}/${play.play_preview}`
                                    "
                                    alt="Play Thumbnail"
                                    class="
                                        bg-white
                                        flex-grow flex-shrink
                                        w-full
                                        rounded-md
                                        my-4
                                        object-contain
                                    "
                                    :style="{
                                        backgroundImage: `linear-gradient(to bottom, #fffa, #fffa), url('${play.background}')`,
                                        backgroundSize: 'contain',
                                        backgroundRepeat: 'no-repeat',
                                        aspectRatio: 2.07339829981,
                                    }"
                                    onerror="this.onerror=null;this.src='/default-images/dummy-play.png';this.style.backgroundImage = 'none';"
                                />
                            </div>
                        </a>

                        <div class="flex justify-center">
                            <button
                                class="
                                    bg-gradient-to-br
                                    from-red-400
                                    to-red-500
                                    text-white
                                    rounded-lg
                                    p-1
                                    px-4
                                    mt-4
                                "
                                @click="untagPlay(play)"
                            >
                                Un-tag
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { computed, onMounted, reactive } from "vue";
import LoadingCircle from "./LoadingCircle.vue";
import ModalCustom from "./ModalCustom.vue";
import AppButton from "./AppButton.vue";

const props = defineProps({
    video: {
        type: Object,
        required: true,
    },
    href: {
        type: String,
        required: true,
    },
    show: {
        type: Boolean,
        default: false,
    },
});
const emit = defineEmits(["loaded"]);
const state = reactive({
    isLoadModalOpen: props.show ?? false,
    tags: [],
});

const tryCloseLoadModal = () => {
    if (state.isLoading) {
        return;
    }

    state.isLoadModalOpen = false;
    state.tags = [];

    const url = new URL(window.location.href);
    let params = new URLSearchParams(url.search);
    params.delete("show-play");
    history.pushState({}, null, `${url.pathname}?${params.toString()}`);
};

async function tryOpenModal() {
    emit("loaded");
    state.isLoadModalOpen = true;
    state.isLoading = true;
    try {
        await refreshData();
    } catch {}
    state.isLoading = false;
}

async function untagPlay(play) {
    if (!play) {
        return;
    }
    await axios.post("/plays/untag-video", {
        play_id: play.play_id,
        video_id: props.video.id,
    });
    refreshData();
}

async function refreshData() {
    state.tags = (await axios.get(`/video/${props.video.id}/tags`, {})).data;
}

onMounted(() => {
    refreshData();
});
</script>

<style scoped></style>
